import { BasePaginatorDto } from '@diritto/common/base/paginator/paginator.dto';
import { CategoryType, ContentOrderType } from '@diritto/common/content/constants';
import { ContentSearchRelayResponseDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { Http } from '@diritto/common/utils/requester/http';

export interface GetSearchQuery {
  includeAdult: boolean;
  categoryType?: CategoryType;
  contentOrderType?: ContentOrderType;
  showOnlySerialized?: boolean;
}

export class SearchApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async searchRelayContents(keyword: string, param: BasePaginatorDto & GetSearchQuery) {
    const res = await this.http.get<ContentSearchRelayResponseDto>(`${this.url}/relay/contents/search`, {
      params: { q: keyword, ...param },
    });
    return res.data;
  }
}
